// SBIS Consulting — Kurs (Exchange Rate tracking by day)
// Auto-fetch pri otvaranju, čuvanje po danima, edit/delete

import { state } from './state.js';
import { sb } from './supabase.js';
import { toast, svgIcon, openEditModal, showLoading, hideLoading, showConfirm } from './ui.js';
import { fNum } from './utils.js';

let ratesData = [];

export async function loadKursPage() {
  showLoading();
  try {
    const { data, error } = await sb.rpc('get_exchange_rates', { p_limit: 90 });
    if (error) throw error;
    ratesData = data || [];
  } catch (e) { ratesData = []; toast('Greška pri učitavanju kurseva', 'err'); }
  hideLoading();
  renderKursPage();

  // Auto-fetch kurs za danas ako nije sačuvan
  const todayStr = new Date().toISOString().slice(0, 10);
  const todayRate = ratesData.find(r => r.rate_date === todayStr);
  if (!todayRate) {
    autoFetchAndSave();
  }
}

async function autoFetchAndSave() {
  try {
    const resp = await fetch('/api/exchange-rate');
    const data = await resp.json();
    if (data.success && data.rates && data.rates.USD_RSD) {
      const todayStr = new Date().toISOString().slice(0, 10);
      const { error } = await sb.rpc('upsert_exchange_rate', {
        p_user_id: state.CU.id,
        p_date: todayStr,
        p_usd_rsd: data.rates.USD_RSD,
        p_eur_rsd: data.rates.EUR_RSD || 0,
        p_source: 'auto-api'
      });
      if (!error) {
        toast('Kurs za danas automatski preuzet i sačuvan');
        loadKursPage();
      }
    }
  } catch (e) { /* tiho — korisnik može ručno */ }
}

export function renderKursPage() {
  const container = document.getElementById('kursContent');
  if (!container) return;
  container.textContent = '';

  const todayStr = new Date().toISOString().slice(0, 10);
  const todayRate = ratesData.find(r => r.rate_date === todayStr);

  // Today's rate card
  const todayCard = document.createElement('div');
  todayCard.className = 'card';
  todayCard.style.cssText = 'margin-bottom:20px;padding:24px';

  const h3 = document.createElement('h3');
  h3.style.cssText = 'font-size:14px;color:var(--tx2);margin-bottom:16px';
  h3.textContent = 'Današnji kurs — ' + new Date().toLocaleDateString('sr-RS');
  todayCard.appendChild(h3);

  const form = document.createElement('div');
  form.style.cssText = 'display:flex;gap:16px;align-items:flex-end;flex-wrap:wrap';

  const usdGrp = document.createElement('div'); usdGrp.style.flex = '1';
  const usdLbl = document.createElement('label'); usdLbl.className = 'fl'; usdLbl.textContent = '1 USD = ? RSD';
  const usdInp = document.createElement('input'); usdInp.type = 'number'; usdInp.className = 'fi'; usdInp.id = 'kursUsdInput'; usdInp.style.width = '100%'; usdInp.step = '0.01';
  usdInp.value = todayRate ? parseFloat(todayRate.usd_rsd).toFixed(2) : '';
  usdInp.placeholder = 'npr. 108.50';
  usdGrp.appendChild(usdLbl); usdGrp.appendChild(usdInp);

  const eurGrp = document.createElement('div'); eurGrp.style.flex = '1';
  const eurLbl = document.createElement('label'); eurLbl.className = 'fl'; eurLbl.textContent = '1 EUR = ? RSD';
  const eurInp = document.createElement('input'); eurInp.type = 'number'; eurInp.className = 'fi'; eurInp.id = 'kursEurInput'; eurInp.style.width = '100%'; eurInp.step = '0.01';
  eurInp.value = todayRate ? parseFloat(todayRate.eur_rsd).toFixed(2) : '';
  eurInp.placeholder = 'npr. 117.20';
  eurGrp.appendChild(eurLbl); eurGrp.appendChild(eurInp);

  const btnGrp = document.createElement('div'); btnGrp.style.cssText = 'display:flex;gap:8px';
  const fetchBtn = document.createElement('button'); fetchBtn.className = 'bsm';
  fetchBtn.appendChild(svgIcon('refresh', 14)); fetchBtn.appendChild(document.createTextNode(' Preuzmi kurs'));
  fetchBtn.onclick = fetchTodayRate;
  const saveBtn = document.createElement('button'); saveBtn.className = 'bsav'; saveBtn.style.cssText = 'padding:10px 20px';
  saveBtn.appendChild(svgIcon('save', 14)); saveBtn.appendChild(document.createTextNode(' Sačuvaj'));
  saveBtn.onclick = saveTodayRate;
  btnGrp.appendChild(fetchBtn); btnGrp.appendChild(saveBtn);

  form.appendChild(usdGrp); form.appendChild(eurGrp); form.appendChild(btnGrp);
  todayCard.appendChild(form);

  if (todayRate) {
    const st = document.createElement('div');
    st.style.cssText = 'margin-top:12px;font-size:12px;color:var(--suc)';
    st.textContent = '\u2713 Kurs za danas sačuvan (izvor: ' + (todayRate.source || 'manual') + ')';
    todayCard.appendChild(st);
  }

  container.appendChild(todayCard);

  // History table
  const histCard = document.createElement('div'); histCard.className = 'card'; histCard.style.cssText = 'padding:0;overflow:hidden';

  if (!ratesData.length) {
    const empty = document.createElement('div'); empty.style.cssText = 'text-align:center;padding:40px;color:var(--tx3)';
    empty.textContent = 'Nema sačuvanih kurseva. Kurs se automatski preuzima pri otvaranju stranice.';
    histCard.appendChild(empty);
  } else {
    const tbl = document.createElement('table'); tbl.className = 'dtbl';
    const thead = document.createElement('thead'); const htr = document.createElement('tr');
    [{ h: 'Datum', a: 'left', w: '' }, { h: '1 USD = RSD', a: 'right', w: '14%' }, { h: '1 EUR = RSD', a: 'right', w: '14%' }, { h: 'Izvor', a: 'center', w: '10%' }, { h: 'Ažurirano', a: 'left', w: '14%' }, { h: 'Akcije', a: 'center', w: '10%' }].forEach(c => { const th = document.createElement('th'); th.textContent = c.h; th.style.textAlign = c.a; if (c.w) th.style.width = c.w; htr.appendChild(th); });
    thead.appendChild(htr); tbl.appendChild(thead);

    const tbody = document.createElement('tbody');
    ratesData.forEach(r => {
      const tr = document.createElement('tr');
      const isToday = r.rate_date === todayStr;
      if (isToday) tr.style.background = 'var(--acc-g)';

      const td1 = document.createElement('td'); td1.style.cssText = 'font-family:var(--mn);font-weight:600';
      td1.textContent = new Date(r.rate_date + 'T00:00:00').toLocaleDateString('sr-RS') + (isToday ? ' (danas)' : '');

      const td2 = document.createElement('td'); td2.style.cssText = 'font-family:var(--mn);text-align:right;font-weight:600;color:var(--acc)';
      td2.textContent = r.usd_rsd > 0 ? fNum(parseFloat(r.usd_rsd)) : '\u2014';

      const td3 = document.createElement('td'); td3.style.cssText = 'font-family:var(--mn);text-align:right;font-weight:600;color:var(--suc)';
      td3.textContent = r.eur_rsd > 0 ? fNum(parseFloat(r.eur_rsd)) : '\u2014';

      const td4 = document.createElement('td'); td4.style.cssText = 'font-size:11px;color:var(--tx3)';
      const badge = document.createElement('span');
      badge.style.cssText = 'padding:2px 8px;border-radius:10px;font-size:10px;background:' + (r.source === 'auto-api' ? 'var(--suc-bg);color:var(--suc)' : 'var(--acc-g);color:var(--acc)');
      badge.textContent = r.source === 'auto-api' ? 'Auto' : 'Ručno';
      td4.appendChild(badge);

      const td5 = document.createElement('td'); td5.style.cssText = 'font-size:11px;color:var(--tx3)';
      td5.textContent = r.updated_at ? new Date(r.updated_at).toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';

      const td6 = document.createElement('td'); td6.style.cssText = 'white-space:nowrap;text-align:center';
      const btnEd = document.createElement('button'); btnEd.className = 'bsm'; btnEd.style.cssText = 'margin-right:6px;font-size:11px;padding:5px 10px';
      btnEd.appendChild(svgIcon('edit', 12)); btnEd.appendChild(document.createTextNode(' Izmeni'));
      btnEd.onclick = () => editRate(r);
      const btnDel = document.createElement('button'); btnDel.className = 'bsm dng'; btnDel.style.cssText = 'font-size:11px;padding:5px 10px';
      btnDel.appendChild(svgIcon('trash', 12)); btnDel.appendChild(document.createTextNode(' Obriši'));
      btnDel.onclick = () => deleteRate(r);
      td6.appendChild(btnEd); td6.appendChild(btnDel);

      tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5); tr.appendChild(td6);
      tbody.appendChild(tr);
    });
    tbl.appendChild(tbody); histCard.appendChild(tbl);
  }

  container.appendChild(histCard);
}

async function fetchTodayRate() {
  const usdInp = document.getElementById('kursUsdInput');
  const eurInp = document.getElementById('kursEurInput');
  if (!usdInp || !eurInp) return;
  usdInp.disabled = true; eurInp.disabled = true;
  try {
    const resp = await fetch('/api/exchange-rate');
    const data = await resp.json();
    if (data.success && data.rates) {
      if (data.rates.USD_RSD) usdInp.value = data.rates.USD_RSD.toFixed(2);
      if (data.rates.EUR_RSD) eurInp.value = data.rates.EUR_RSD.toFixed(2);
      toast('Kurs preuzet (' + (data.source || 'API') + ')');
    } else { toast('Nije moguće preuzeti kurs', 'err'); }
  } catch (e) { toast('Greška pri preuzimanju kursa', 'err'); }
  usdInp.disabled = false; eurInp.disabled = false;
}

async function saveTodayRate() {
  const usd = parseFloat(document.getElementById('kursUsdInput')?.value) || 0;
  const eur = parseFloat(document.getElementById('kursEurInput')?.value) || 0;
  if (!usd && !eur) { toast('Unesite bar jedan kurs', 'err'); return; }
  try {
    const { error } = await sb.rpc('upsert_exchange_rate', {
      p_user_id: state.CU.id, p_date: new Date().toISOString().slice(0, 10),
      p_usd_rsd: usd, p_eur_rsd: eur, p_source: 'manual'
    });
    if (error) throw error;
    toast('Kurs sačuvan'); loadKursPage();
  } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
}

function editRate(r) {
  openEditModal('Izmeni kurs za ' + new Date(r.rate_date + 'T00:00:00').toLocaleDateString('sr-RS'), [
    { label: '1 USD = RSD', value: r.usd_rsd || '', key: 'usd_rsd', type: 'number', step: '0.01' },
    { label: '1 EUR = RSD', value: r.eur_rsd || '', key: 'eur_rsd', type: 'number', step: '0.01' }
  ], async (vals) => {
    try {
      const { error } = await sb.rpc('upsert_exchange_rate', {
        p_user_id: state.CU.id, p_date: r.rate_date,
        p_usd_rsd: parseFloat(vals.usd_rsd) || 0, p_eur_rsd: parseFloat(vals.eur_rsd) || 0, p_source: 'manual'
      });
      if (error) throw error;
      toast('Kurs ažuriran'); loadKursPage();
    } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
  });
}

function deleteRate(r) {
  showConfirm('Obrisati kurs za ' + new Date(r.rate_date + 'T00:00:00').toLocaleDateString('sr-RS') + '?', async () => {
    try {
      const { error } = await sb.from('exchange_rates').delete().eq('id', r.id);
      if (error) throw error;
      toast('Kurs obrisan'); loadKursPage();
    } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
  });
}
